import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `NivelGenetico/editNivelGenetico`, method: 'POST', body: values, token: token})
}
